function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.94182 20.0279V17.4261L2.90984 11.3941L8.94182 5.36211V2.76025L0.307617 11.3945L8.94182 20.0279Z",
  fill: "#A7A7A7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7021 23H13.5421L17.2221 0H15.3821L11.7021 23Z",
  fill: "#A7A7A7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9814 2.97192V5.57378L26.0134 11.6058L19.9814 17.6377V20.2396L28.6156 11.6054L19.9814 2.97192Z",
  fill: "#A7A7A7"
});

var SvgOpenPaper = function SvgOpenPaper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenPaper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open_paper.b548d09a.svg";
export { ForwardRef as ReactComponent };